import {
    LOGIN_SUCCESS, LOGIN_FAIL, USER_LOADED_SUCCESS,
    USER_LOADED_FAIL, AUTHENTICATED_SUCCESS,
    AUTHENTICATED_FAIL, REFRESH_TOKEN_USED_SUCCESS,
    REFRESH_TOKEN_USED_FAIL, PASSWORD_RESET_SUCCESS,
    PASSWORD_RESET_FAIL, PASSWORD_RESET_CONFIRM_SUCCESS,
    PASSWORD_RESET_CONFIRM_FAIL, SIGNUP_SUCCESS,
    SIGNUP_FAIL, ACTIVATION_SUCCESS, ACTIVATION_FAIL,
    LOGOUT, NETWORK_ERROR, AUTHORIZED_FAIL, LOADING
} from '../actions/types';

const initialState = {
    access: localStorage.getItem('access'),
    refresh: localStorage.getItem('refresh'),
    isAuthenticated: null,
    isLoading: true,
    role: null,
    user: null,
    networkError: false,
};


// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case AUTHENTICATED_SUCCESS:
            return {
                ...state,
                isAuthenticated: true, isLoading: false
            }
        case LOGIN_SUCCESS:
            localStorage.setItem('access', payload.access);
            localStorage.setItem('refresh', payload.refresh);
            return {
                ...state,
                isAuthenticated: true,
                isLoading: false,
                access: payload.access,
                refresh: payload.refresh
            }
        case REFRESH_TOKEN_USED_SUCCESS:
            localStorage.setItem('access', payload.access);
            return {
                ...state,
                isAuthenticated: true,
                access: payload.access, isLoading: false
            }
        case SIGNUP_SUCCESS:
            return {
                ...state,
                isAuthenticated: false, isLoading: false
            }
        case USER_LOADED_SUCCESS:
            return {
                ...state,
                user: payload.user, role: payload.role, isAuthenticated:true, isLoading: false
            }
        case AUTHENTICATED_FAIL:
            return {
                ...state,
                isAuthenticated: false, isLoading: false
            }
        case REFRESH_TOKEN_USED_FAIL:
            return {
                ...state,
                isAuthenticated: false, isLoading: false
            }
        case USER_LOADED_FAIL:
            return {
                ...state,
                user: null, isLoading: false
            }
        case AUTHORIZED_FAIL:
            return {
                ...state,
                isAdmin: false,
                isInstructor: false,
                isStudent: false, isLoading: false
            }
        case LOGIN_FAIL:
        case SIGNUP_FAIL:
        case LOGOUT:
            localStorage.removeItem('access');
            localStorage.removeItem('refresh');
            return {
                ...state,
                access: null,
                refresh: null,
                isAuthenticated: false,
                user: null, role:null, isLoading: false
            }
        case NETWORK_ERROR:
            localStorage.removeItem('access');
            localStorage.removeItem('refresh');
            return {
                ...state,
                access: null,
                refresh: null,
                isAuthenticated: false,
                user: null, isLoading: false,
                networkError: true
            }
        case PASSWORD_RESET_SUCCESS:
        case PASSWORD_RESET_FAIL:
        case PASSWORD_RESET_CONFIRM_SUCCESS:
        case PASSWORD_RESET_CONFIRM_FAIL:
        case ACTIVATION_SUCCESS:
        case ACTIVATION_FAIL:
            return {
                ...state
            }
        case LOADING:
            return { ...state , isLoading : true}
        default:
            return state
    }
};